// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminDashboardPage {
  background: var(--white-principale);
  min-height: 100vh;
  padding: 12px 0 26px;
  font-family: Arial, sans-serif;
}

/* Header */
.adminDashboardHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin: 14px 0 14px;
}

.adminDashboardTitle {
  font-weight: 900;
  font-size: 18px;
  color: var(--couleur-principale);
}

.adminDashboardSubtitle {
  margin-top: 4px;
  font-size: 12px;
  color: var(--gris-terciaire);
}

.adminDashboardBtn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 10px;
  padding: 10px 12px;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
}

.adminDashboardBtnSoft {
  background: var(--white-text);
  color: var(--couleur-dark);
}

.adminDashboardBtnSoft:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.adminDashboardBtnPrimary {
  background: var(--couleur-dark);
  color: var(--white-principale);
}

.adminDashboardBtnPrimary:hover {
  background: var(--couleur-secondaire);
  color: var(--white-principale);
}

/* KPI cards */
.adminDashboardKpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.adminDashboardKpiCard {
  background: var(--white-principale);
  border-radius: 14px;
  padding: 14px;
  box-shadow: 0 1px 10px var(--gris-shadow);
  display: flex;
  gap: 12px;
  text-decoration: none;
  color: inherit;
  transition:
    transform 0.12s ease,
    box-shadow 0.12s ease;
}

.adminDashboardKpiCard:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px var(--gris-principale);
}

.kpiIcon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  font-size: 18px;
}

.kpiUsers {
  background: var(--kpi-users-bg);
  color: var(--kpi-users-fg);
}
.kpiArticles {
  background: var(--kpi-articles-bg);
  color: var(--kpi-articles-fg);
}
.kpiPaiements {
  background: var(--kpi-paiements-bg);
  color: var(--kpi-paiements-fg);
}
.kpiSignal {
  background: var(--kpi-signal-bg);
  color: var(--kpi-signal-fg);
}

.kpiBody {
  flex: 1 1;
  min-width: 0;
}
.kpiLabel {
  font-size: 12px;
  color: var(--kpi-value-color);
  font-weight: 800;
}
.kpiValue {
  font-size: 20px;
  font-weight: 900;
  color: var(--kpi-value-color);
  margin-top: 4px;
}
.kpiHint {
  margin-top: 6px;
  font-size: 12px;
  color: var(--gris-terciaire);
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.kpiPill {
  padding: 3px 8px;
  border-radius: 999px;
  font-weight: 800;
  font-size: 11px;
}

.kpiGood {
  background: var(--vert-principale);
  color: var(--white-principale);
}
.kpiWarn {
  background: var(--orange-secondaire);
  color: var(--white-principale);
}
.kpiBad {
  background: var(--couleur-secondaire);
  color: var(--white-principale);
}

/* Revenue block */
.adminDashboardRevenue {
  margin-top: 12px;
  background: linear-gradient(
    135deg,
    var(--couleur-dark),
    var(--couleur-principale)
  );
  color: var(--white-principale);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.revenueTitle {
  font-weight: 900;
  font-size: 12px;
  opacity: 0.9;
}

.revenueValue {
  font-size: 20px;
  font-weight: 900;
  margin-top: 6px;
}

.revenueHint {
  font-size: 12px;
  opacity: 0.85;
  margin-top: 4px;
}

/* Panels grid */
.adminDashboardGrid {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.adminDashboardPanel {
  background: var(--white-principale);
  border-radius: 14px;
  padding: 14px;
  box-shadow: 0 1px 10px var(--gris-shadow);
  overflow: hidden;
}

.panelHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.panelTitle {
  font-size: 14px;
  font-weight: 900;
  color: var(--couleur-principale);
}

.panelSubtitle {
  font-size: 12px;
  color: var(--gris-terciaire);
  margin-top: 2px;
}

.panelLink {
  font-size: 12px;
  font-weight: 900;
  color: var(--couleur-secondaire);
  text-decoration: none;
  white-space: nowrap;
}

.panelList {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.panelRow {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 10px;
  border-radius: 12px;
  background: var(--gris-foncer);
}

.panelMain {
  min-width: 0;
}

.panelStrong {
  font-weight: 900;
  font-size: 13px;
  color: var(--couleur-dark);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 420px;
}

.panelMuted {
  margin-top: 3px;
  font-size: 12px;
  color: var(--gris-terciaire);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 460px;
}

.panelMeta {
  font-size: 12px;
  color: var(--gris-terciaire);
  white-space: nowrap;
}

.panelEmpty {
  padding: 14px;
  border-radius: 12px;
  background: var(--gris-foncer);
  color: var(--gris-terciaire);
  font-weight: 700;
  text-align: center;
}

/* small pill in lists */
.pill {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 900;
}

/* Quick actions */
.adminDashboardQuick {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.quickBtn {
  background: var(--white-principale);
  border-radius: 12px;
  padding: 10px 12px;
  font-weight: 900;
  text-decoration: none;
  color: var(--couleur-dark);
  box-shadow: 0 1px 10px var(--gris-shadow);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.quickBtn:hover {
  color: var(--couleur-principale);
}

/* Responsive */
@media (max-width: 992px) {
  .adminDashboardKpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .adminDashboardGrid {
    grid-template-columns: 1fr;
  }
  .panelStrong,
  .panelMuted {
    max-width: 240px;
  }
}

@media (max-width: 520px) {
  .adminDashboardHeader {
    flex-direction: column;
    align-items: stretch;
  }
  .adminDashboardRevenue {
    flex-direction: column;
    align-items: stretch;
  }
  .adminDashboardBtn {
    width: 100%;
    justify-content: center;
  }
}

/* ===== Stats de publication ===== */
.adminDashboardStatsPanel {
  margin-top: 15px; /* ← gap entre Revenue bar et le chart */
}

.statsControls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.statsSelectGroup {
  display: flex;
  gap: 8px;
}

.statsSelect {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  color: #1e293b;
  background: #fff;
  cursor: pointer;
}

.statsDateRange {
  display: flex;
  align-items: center;
  gap: 8px;
}

.statsDateField {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #475569;
}

.statsDateField input[type="date"] {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 13px;
  color: #1e293b;
}

.statsResetBtn {
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.statsResetBtn:hover {
  color: #ef4444;
}

/* Regroupe le bouton "Appliquer" et le reset sur une même ligne (utile en mobile) */
.statsActionsRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.statsActionsRow .adminDashboardBtnPrimary {
  flex: 1 1;
}

.statsActionsRow .statsResetBtn {
  flex: 0 0 auto;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  width: 40px;
  height: 40px;
  justify-content: center;
}

.statsActionsRow .statsResetBtn:hover {
  background: #fef2f2;
  border-color: #fecaca;
}

/* Légende */
.statsLegend {
  display: flex;
  gap: 16px;
  padding: 8px 16px 0;
  font-size: 12px;
  color: #475569;
}

.statsLegendItem {
  display: flex;
  align-items: center;
  gap: 6px;
}

.statsLegendDot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.statsDotActif {
  background: #22c55e;
}
.statsDotAttente {
  background: #f59e0b;
}
.statsDotNonActif {
  background: #ef4444;
}

/* Chart */
.statsChartWrap {
  padding: 16px 8px 4px;
  overflow-x: auto;
}

.statsChart {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  min-height: 180px;
  min-width: max-content;
}

.statsBarCol {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: auto;
  flex-shrink: 0;
}

.statsBarValue {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}

.statsBarTrack {
  width: 100%;
  height: 140px;
  display: flex;
  flex-direction: column-reverse;
  background: #f1f5f9;
  border-radius: 6px;
  overflow: hidden;
}

.statsBarSegment {
  width: 100%;
  transition: height 0.3s ease;
}

.statsSegActif {
  background: #22c55e;
}
.statsSegAttente {
  background: #f59e0b;
}
.statsSegNonActif {
  background: #ef4444;
}

.statsBarLabel {
  margin-top: 6px;
  font-size: 11px;
  color: #64748b;
  text-align: center;
  white-space: nowrap;
}

/* ===== Tableau des stats d'annonces — redesign ===== */
.statsAnnoncesTableWrap {
  overflow-x: auto;
  overflow-y: auto;
  border-radius: 14px;
  border: 1px solid #eef1f6;
  min-height: 372px; /* en-tête (~40px) + 5 lignes (~66px) : hauteur stable même avec moins de résultats */
}

.statsAnnoncesTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
  min-width: 1100px; /* force le scroll horizontal proprement */
}

.statsAnnoncesTable thead th {
  position: sticky;
  top: 0;
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  text-align: left;
  padding: 10px 14px;
  white-space: nowrap;
  z-index: 1;
}

.statsAnnoncesTable tbody tr {
  height: 66px; /* hauteur mini par ligne */
}

.statsAnnoncesTable tbody td {
  padding: 10px 14px;
  color: #334155;
  vertical-align: middle;
}

.statsAnnoncesTable tbody tr:hover {
  background: #f1f5f9;
}

.statsAnnoncesTable tbody tr:last-child td {
  border-bottom: none;
}

/* Colonne Article figée au scroll horizontal (desktop) */
.colSticky {
  position: sticky;
  left: 0;
  background: inherit;
  z-index: 2;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.04);
}

thead .colSticky {
  z-index: 3;
  background: #f8fafc;
}

.colNum {
  text-align: center;
}

/* Cellules avec valeurs potentiellement longues (UTM, referrer) */
.cellTruncate {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #64748b;
  font-size: 12px;
}

/* Badges */
.statBadge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.statBadgeViews {
  background: #eff6ff;
  color: #2563eb;
}

.statBadgeDevice {
  background: #f0fdf4;
  color: #16a34a;
  text-transform: capitalize;
}

.statBadgeSource {
  background: #fff7ed;
  color: #ea580c;
  text-transform: capitalize;
}

.statBadgeCampaign {
  background: #faf5ff;
  color: #9333ea;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
.tablePagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
  flex-wrap: wrap;
}

.tablePaginationInfo {
  font-size: 12px;
  color: var(--gris-terciaire);
  font-weight: 700;
}

.tablePaginationBtns {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tablePageBtn {
  border: 1px solid #e2e8f0;
  background: #fff;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #475569;
  transition: background 0.12s ease;
}

.tablePageBtn:hover:not(:disabled) {
  background: #f1f5f9;
}

.tablePageBtn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.tablePageCurrent {
  font-weight: 900;
  font-size: 13px;
  color: var(--couleur-dark);
  min-width: 20px;
  text-align: center;
}
/* Badges supplémentaires */
.statBadgeIdentified {
  background: #ecfdf5;
  color: #059669;
}

.statBadgeAnonymous {
  background: #f1f5f9;
  color: #64748b;
}

.statBadgeType {
  background: #eef2ff;
  color: #4f46e5;
}

/* Bouton action */
.tableActionBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: var(--couleur-dark);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease;
}

.tableActionBtn:hover {
  background: #f1f5f9;
}

/* ===== Modal détails événements ===== */
.aeModalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}

.aeModal {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 1200px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.aeModalHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.aeModalTitle {
  font-weight: 900;
  font-size: 15px;
  color: var(--couleur-principale);
}

.aeModalSubtitle {
  font-size: 12px;
  color: var(--gris-terciaire);
  margin-top: 2px;
}

.aeModalCloseBtn {
  border: none;
  background: #f1f5f9;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #475569;
}

.aeModalCloseBtn:hover {
  background: #e2e8f0;
}

.aeModalBody {
  padding: 16px 20px;
  overflow-y: auto;
  flex: 1 1;
}

.aeModalTableWrap {
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid #eef1f6;
}

.aeModal .tablePagination {
  padding: 12px 20px 16px;
  margin-top: 0;
}

.statBadgeStack {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}

.statBadgeStack .statBadge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.statBadgeStack .statBadge i {
  font-size: 11px;
}

/* ===== Responsive : panneau statistiques annonces (filtres) ===== */
@media (max-width: 768px) {
  .adminDashboardStatsPanel .panelHeader {
    flex-direction: column;
    align-items: stretch;
  }

  .statsControls {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  /* Groupes de champs (mois/année, du/au) en grille 2 colonnes plutôt qu'empilés un par un */
  .statsSelectGroup,
  .statsDateRange {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    width: 100%;
  }

  .statsDateField {
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
    min-width: 0;
  }

  .statsDateField span {
    font-size: 11px;
    font-weight: 700;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .statsDateField input[type="date"] {
    width: 100%;
    min-height: 40px;
    padding: 8px 10px;
  }

  /* Le bouton reset ne casse plus la grille du/au quand il est inline dans statsDateRange */
  .statsDateRange .statsResetBtn {
    grid-column: 1 / -1;
    justify-content: center;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    height: 36px;
  }

  .statsSelect {
    width: 100%;
    min-height: 40px;
    text-align: center;
    justify-content: center;
  }

  .statsControls > .adminDashboardBtnPrimary,
  .statsActionsRow {
    width: 100%;
  }

  .statsAnnoncesTable {
    min-width: 760px;
    font-size: 12px;
  }

  .statsAnnoncesTable thead th,
  .statsAnnoncesTable tbody td {
    padding: 8px 10px;
  }

  .panelStrong {
    max-width: 160px;
  }

  .cellTruncate {
    max-width: 110px;
  }
}

/* Très petits écrans : une seule colonne pour éviter des dates trop compressées */
@media (max-width: 420px) {
  .statsSelectGroup,
  .statsDateRange {
    grid-template-columns: 1fr;
  }

  .statsDateRange .statsResetBtn {
    grid-column: auto;
  }
}

/* ===== Responsive : tableau statistiques annonces — cartes en scroll horizontal ===== */
@media (max-width: 640px) {
  .statsAnnoncesTableWrap {
    border: none;
    min-height: 0;
    overflow: visible;
  }

  .statsAnnoncesTable,
  .statsAnnoncesTable thead,
  .statsAnnoncesTable tr,
  .statsAnnoncesTable td {
    display: block;
    min-width: 0;
  }

  .statsAnnoncesTable thead {
    position: absolute;
    left: -9999px; /* masqué visuellement, gardé pour l'accessibilité */
  }

  /* Les cartes défilent horizontalement avec effet de snap */
  .statsAnnoncesTable tbody {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    gap: 12px;
    padding: 4px 4px 14px;
    scroll-snap-type: x proximity;
    -webkit-overflow-scrolling: touch;
  }

  .statsAnnoncesTable tbody::-webkit-scrollbar {
    height: 6px;
  }
  .statsAnnoncesTable tbody::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 999px;
  }

  .statsAnnoncesTable tbody tr {
    display: block;
    flex: 0 0 auto;
    width: 78vw;
    max-width: 280px;
    scroll-snap-align: start;
    height: auto;
    background: #fff;
    border: 1px solid #eef1f6;
    border-radius: 14px;
    padding: 12px 14px;
    box-shadow: 0 1px 8px rgba(15, 23, 42, 0.04);
  }

  .statsAnnoncesTable tbody tr:hover {
    background: #fff;
  }

  .statsAnnoncesTable tbody td {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    padding: 8px 0;
    border-bottom: 1px solid #f1f5f9;
    text-align: right;
    position: static;
    box-shadow: none;
    max-width: none;
  }

  .statsAnnoncesTable tbody td:last-child {
    border-bottom: none;
  }

  .statsAnnoncesTable tbody td::before {
    content: attr(data-label);
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #94a3b8;
    text-align: left;
    flex-shrink: 0;
  }

  /* Le titre de l'article devient l'en-tête visuel de la carte */
  .statsAnnoncesTable tbody td.panelStrong.colSticky {
    display: block;
    text-align: left;
    font-size: 14px;
    padding: 0 0 10px;
    border-bottom: 1px solid #f1f5f9;
    margin-bottom: 6px;
    white-space: normal;
    max-width: none;
    position: static;
    box-shadow: none;
  }
  .statsAnnoncesTable tbody td.panelStrong.colSticky::before {
    content: none;
  }

  .statsAnnoncesTable tbody td.colNum {
    justify-content: center;
  }
  .statsAnnoncesTable tbody td.colNum::before {
    content: none;
  }
  .statsAnnoncesTable tbody td.colNum .tableActionBtn {
    width: 100%;
    justify-content: center;
  }

  .cellTruncate {
    max-width: 60%;
    text-align: right;
  }

  .statBadgeStack {
    align-items: flex-end;
  }

  .tablePagination {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .tablePaginationBtns {
    justify-content: center;
  }
}

/* ===== Modal détails événements — plein écran mobile ===== */
@media (max-width: 640px) {
  .aeModalOverlay {
    padding: 0;
    align-items: flex-end;
  }

  .aeModal {
    max-width: 100%;
    width: 100%;
    max-height: 92vh;
    border-radius: 20px 20px 0 0;
    animation: aeModalSlideUp 0.22s ease-out;
  }

  .aeModalHeader {
    padding: 18px 16px 14px;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 2;
  }
  .aeModalHeader::before {
    content: "";
    position: absolute;
    top: 6px;
    left: 50%;
    transform: translateX(-50%);
    width: 36px;
    height: 4px;
    border-radius: 999px;
    background: #e2e8f0;
  }

  .aeModalTitle {
    font-size: 14px;
  }

  .aeModalBody {
    padding: 12px 0 16px 16px;
  }

  /* La table de la modal passe aussi en cartes défilables horizontalement */
  .aeModal .statsAnnoncesTable,
  .aeModal .statsAnnoncesTable thead,
  .aeModal .statsAnnoncesTable tr,
  .aeModal .statsAnnoncesTable td {
    display: block;
  }
  .aeModal .statsAnnoncesTable thead {
    position: absolute;
    left: -9999px;
  }
  .aeModal .statsAnnoncesTable tbody {
    display: flex;
    overflow-x: auto;
    gap: 10px;
    padding: 2px 16px 10px 0;
    scroll-snap-type: x proximity;
    -webkit-overflow-scrolling: touch;
  }
  .aeModal .statsAnnoncesTable tbody::-webkit-scrollbar {
    height: 6px;
  }
  .aeModal .statsAnnoncesTable tbody::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 999px;
  }
  .aeModal .statsAnnoncesTable tbody tr {
    flex: 0 0 auto;
    width: 72vw;
    max-width: 260px;
    scroll-snap-align: start;
    border: 1px solid #eef1f6;
    border-radius: 12px;
    padding: 10px 12px;
  }
  .aeModal .statsAnnoncesTable tbody td {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 6px 0;
    border-bottom: 1px solid #f8fafc;
    text-align: right;
  }
  .aeModal .statsAnnoncesTable tbody td::before {
    content: attr(data-label);
    font-size: 11px;
    font-weight: 800;
    color: #94a3b8;
    text-transform: uppercase;
  }

  .aeModal .tablePagination {
    padding: 10px 16px 14px;
    flex-direction: column;
    gap: 8px;
  }
}

@keyframes aeModalSlideUp {
  from {
    transform: translateY(24px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/admin/dashbordAdmin/AdminDashboardPage.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd;;yBAEuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;AACA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB;;;;GAIC;EACD,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE;IACE,gDAAgD;EAClD;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,qCAAqC;AACrC;EACE,gBAAgB,EAAE,wCAAwC;AAC5D;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,oFAAoF;AACpF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB,EAAE,qFAAqF;AAC1G;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,iBAAiB,EAAE,0CAA0C;AAC/D;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY,EAAE,2BAA2B;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,gBAAgB;EAChB,OAAO;EACP,mBAAmB;EACnB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;AACA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,qEAAqE;AACrE;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA,2FAA2F;EAC3F;;IAEE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,0FAA0F;EAC1F;IACE,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,kFAAkF;AAClF;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,yFAAyF;AACzF;EACE;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;;;;IAIE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa,EAAE,oDAAoD;EACrE;;EAEA,2DAA2D;EAC3D;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,qBAAqB;IACrB,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,cAAc;EAChB;;EAEA,+DAA+D;EAC/D;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,wCAAwC;EAC1C;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,0EAA0E;EAC1E;;;;IAIE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,wBAAwB;IACxB,6BAA6B;IAC7B,iCAAiC;EACnC;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,gCAAgC;IAChC,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[".adminDashboardPage {\n  background: var(--white-principale);\n  min-height: 100vh;\n  padding: 12px 0 26px;\n  font-family: Arial, sans-serif;\n}\n\n/* Header */\n.adminDashboardHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 14px 0 14px;\n}\n\n.adminDashboardTitle {\n  font-weight: 900;\n  font-size: 18px;\n  color: var(--couleur-principale);\n}\n\n.adminDashboardSubtitle {\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--gris-terciaire);\n}\n\n.adminDashboardBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 0;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-weight: 700;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.adminDashboardBtnSoft {\n  background: var(--white-text);\n  color: var(--couleur-dark);\n}\n\n.adminDashboardBtnSoft:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.adminDashboardBtnPrimary {\n  background: var(--couleur-dark);\n  color: var(--white-principale);\n}\n\n.adminDashboardBtnPrimary:hover {\n  background: var(--couleur-secondaire);\n  color: var(--white-principale);\n}\n\n/* KPI cards */\n.adminDashboardKpis {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.adminDashboardKpiCard {\n  background: var(--white-principale);\n  border-radius: 14px;\n  padding: 14px;\n  box-shadow: 0 1px 10px var(--gris-shadow);\n  display: flex;\n  gap: 12px;\n  text-decoration: none;\n  color: inherit;\n  transition:\n    transform 0.12s ease,\n    box-shadow 0.12s ease;\n}\n\n.adminDashboardKpiCard:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 20px var(--gris-principale);\n}\n\n.kpiIcon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  font-size: 18px;\n}\n\n.kpiUsers {\n  background: var(--kpi-users-bg);\n  color: var(--kpi-users-fg);\n}\n.kpiArticles {\n  background: var(--kpi-articles-bg);\n  color: var(--kpi-articles-fg);\n}\n.kpiPaiements {\n  background: var(--kpi-paiements-bg);\n  color: var(--kpi-paiements-fg);\n}\n.kpiSignal {\n  background: var(--kpi-signal-bg);\n  color: var(--kpi-signal-fg);\n}\n\n.kpiBody {\n  flex: 1;\n  min-width: 0;\n}\n.kpiLabel {\n  font-size: 12px;\n  color: var(--kpi-value-color);\n  font-weight: 800;\n}\n.kpiValue {\n  font-size: 20px;\n  font-weight: 900;\n  color: var(--kpi-value-color);\n  margin-top: 4px;\n}\n.kpiHint {\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.kpiPill {\n  padding: 3px 8px;\n  border-radius: 999px;\n  font-weight: 800;\n  font-size: 11px;\n}\n\n.kpiGood {\n  background: var(--vert-principale);\n  color: var(--white-principale);\n}\n.kpiWarn {\n  background: var(--orange-secondaire);\n  color: var(--white-principale);\n}\n.kpiBad {\n  background: var(--couleur-secondaire);\n  color: var(--white-principale);\n}\n\n/* Revenue block */\n.adminDashboardRevenue {\n  margin-top: 12px;\n  background: linear-gradient(\n    135deg,\n    var(--couleur-dark),\n    var(--couleur-principale)\n  );\n  color: var(--white-principale);\n  border-radius: 16px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.revenueTitle {\n  font-weight: 900;\n  font-size: 12px;\n  opacity: 0.9;\n}\n\n.revenueValue {\n  font-size: 20px;\n  font-weight: 900;\n  margin-top: 6px;\n}\n\n.revenueHint {\n  font-size: 12px;\n  opacity: 0.85;\n  margin-top: 4px;\n}\n\n/* Panels grid */\n.adminDashboardGrid {\n  margin-top: 12px;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.adminDashboardPanel {\n  background: var(--white-principale);\n  border-radius: 14px;\n  padding: 14px;\n  box-shadow: 0 1px 10px var(--gris-shadow);\n  overflow: hidden;\n}\n\n.panelHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.panelTitle {\n  font-size: 14px;\n  font-weight: 900;\n  color: var(--couleur-principale);\n}\n\n.panelSubtitle {\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  margin-top: 2px;\n}\n\n.panelLink {\n  font-size: 12px;\n  font-weight: 900;\n  color: var(--couleur-secondaire);\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.panelList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.panelRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px;\n  border-radius: 12px;\n  background: var(--gris-foncer);\n}\n\n.panelMain {\n  min-width: 0;\n}\n\n.panelStrong {\n  font-weight: 900;\n  font-size: 13px;\n  color: var(--couleur-dark);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 420px;\n}\n\n.panelMuted {\n  margin-top: 3px;\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 460px;\n}\n\n.panelMeta {\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  white-space: nowrap;\n}\n\n.panelEmpty {\n  padding: 14px;\n  border-radius: 12px;\n  background: var(--gris-foncer);\n  color: var(--gris-terciaire);\n  font-weight: 700;\n  text-align: center;\n}\n\n/* small pill in lists */\n.pill {\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 900;\n}\n\n/* Quick actions */\n.adminDashboardQuick {\n  margin-top: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.quickBtn {\n  background: var(--white-principale);\n  border-radius: 12px;\n  padding: 10px 12px;\n  font-weight: 900;\n  text-decoration: none;\n  color: var(--couleur-dark);\n  box-shadow: 0 1px 10px var(--gris-shadow);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.quickBtn:hover {\n  color: var(--couleur-principale);\n}\n\n/* Responsive */\n@media (max-width: 992px) {\n  .adminDashboardKpis {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .adminDashboardGrid {\n    grid-template-columns: 1fr;\n  }\n  .panelStrong,\n  .panelMuted {\n    max-width: 240px;\n  }\n}\n\n@media (max-width: 520px) {\n  .adminDashboardHeader {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .adminDashboardRevenue {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .adminDashboardBtn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* ===== Stats de publication ===== */\n.adminDashboardStatsPanel {\n  margin-top: 15px; /* ← gap entre Revenue bar et le chart */\n}\n\n.statsControls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.statsSelectGroup {\n  display: flex;\n  gap: 8px;\n}\n\n.statsSelect {\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 13px;\n  color: #1e293b;\n  background: #fff;\n  cursor: pointer;\n}\n\n.statsDateRange {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.statsDateField {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #475569;\n}\n\n.statsDateField input[type=\"date\"] {\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-size: 13px;\n  color: #1e293b;\n}\n\n.statsResetBtn {\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n}\n\n.statsResetBtn:hover {\n  color: #ef4444;\n}\n\n/* Regroupe le bouton \"Appliquer\" et le reset sur une même ligne (utile en mobile) */\n.statsActionsRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.statsActionsRow .adminDashboardBtnPrimary {\n  flex: 1;\n}\n\n.statsActionsRow .statsResetBtn {\n  flex: 0 0 auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  width: 40px;\n  height: 40px;\n  justify-content: center;\n}\n\n.statsActionsRow .statsResetBtn:hover {\n  background: #fef2f2;\n  border-color: #fecaca;\n}\n\n/* Légende */\n.statsLegend {\n  display: flex;\n  gap: 16px;\n  padding: 8px 16px 0;\n  font-size: 12px;\n  color: #475569;\n}\n\n.statsLegendItem {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.statsLegendDot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.statsDotActif {\n  background: #22c55e;\n}\n.statsDotAttente {\n  background: #f59e0b;\n}\n.statsDotNonActif {\n  background: #ef4444;\n}\n\n/* Chart */\n.statsChartWrap {\n  padding: 16px 8px 4px;\n  overflow-x: auto;\n}\n\n.statsChart {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  min-height: 180px;\n  min-width: max-content;\n}\n\n.statsBarCol {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: auto;\n  flex-shrink: 0;\n}\n\n.statsBarValue {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 4px;\n}\n\n.statsBarTrack {\n  width: 100%;\n  height: 140px;\n  display: flex;\n  flex-direction: column-reverse;\n  background: #f1f5f9;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.statsBarSegment {\n  width: 100%;\n  transition: height 0.3s ease;\n}\n\n.statsSegActif {\n  background: #22c55e;\n}\n.statsSegAttente {\n  background: #f59e0b;\n}\n.statsSegNonActif {\n  background: #ef4444;\n}\n\n.statsBarLabel {\n  margin-top: 6px;\n  font-size: 11px;\n  color: #64748b;\n  text-align: center;\n  white-space: nowrap;\n}\n\n/* ===== Tableau des stats d'annonces — redesign ===== */\n.statsAnnoncesTableWrap {\n  overflow-x: auto;\n  overflow-y: auto;\n  border-radius: 14px;\n  border: 1px solid #eef1f6;\n  min-height: 372px; /* en-tête (~40px) + 5 lignes (~66px) : hauteur stable même avec moins de résultats */\n}\n\n.statsAnnoncesTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 13px;\n  min-width: 1100px; /* force le scroll horizontal proprement */\n}\n\n.statsAnnoncesTable thead th {\n  position: sticky;\n  top: 0;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  text-align: left;\n  padding: 10px 14px;\n  white-space: nowrap;\n  z-index: 1;\n}\n\n.statsAnnoncesTable tbody tr {\n  height: 66px; /* hauteur mini par ligne */\n}\n\n.statsAnnoncesTable tbody td {\n  padding: 10px 14px;\n  color: #334155;\n  vertical-align: middle;\n}\n\n.statsAnnoncesTable tbody tr:hover {\n  background: #f1f5f9;\n}\n\n.statsAnnoncesTable tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Colonne Article figée au scroll horizontal (desktop) */\n.colSticky {\n  position: sticky;\n  left: 0;\n  background: inherit;\n  z-index: 2;\n  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.04);\n}\n\nthead .colSticky {\n  z-index: 3;\n  background: #f8fafc;\n}\n\n.colNum {\n  text-align: center;\n}\n\n/* Cellules avec valeurs potentiellement longues (UTM, referrer) */\n.cellTruncate {\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #64748b;\n  font-size: 12px;\n}\n\n/* Badges */\n.statBadge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.statBadgeViews {\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.statBadgeDevice {\n  background: #f0fdf4;\n  color: #16a34a;\n  text-transform: capitalize;\n}\n\n.statBadgeSource {\n  background: #fff7ed;\n  color: #ea580c;\n  text-transform: capitalize;\n}\n\n.statBadgeCampaign {\n  background: #faf5ff;\n  color: #9333ea;\n  max-width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: inline-block;\n}\n.tablePagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #f1f5f9;\n  flex-wrap: wrap;\n}\n\n.tablePaginationInfo {\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  font-weight: 700;\n}\n\n.tablePaginationBtns {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tablePageBtn {\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  border-radius: 8px;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #475569;\n  transition: background 0.12s ease;\n}\n\n.tablePageBtn:hover:not(:disabled) {\n  background: #f1f5f9;\n}\n\n.tablePageBtn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.tablePageCurrent {\n  font-weight: 900;\n  font-size: 13px;\n  color: var(--couleur-dark);\n  min-width: 20px;\n  text-align: center;\n}\n/* Badges supplémentaires */\n.statBadgeIdentified {\n  background: #ecfdf5;\n  color: #059669;\n}\n\n.statBadgeAnonymous {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.statBadgeType {\n  background: #eef2ff;\n  color: #4f46e5;\n}\n\n/* Bouton action */\n.tableActionBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: var(--couleur-dark);\n  border-radius: 8px;\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease;\n}\n\n.tableActionBtn:hover {\n  background: #f1f5f9;\n}\n\n/* ===== Modal détails événements ===== */\n.aeModalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 16px;\n}\n\n.aeModal {\n  background: #fff;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 1200px;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n}\n\n.aeModalHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.aeModalTitle {\n  font-weight: 900;\n  font-size: 15px;\n  color: var(--couleur-principale);\n}\n\n.aeModalSubtitle {\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  margin-top: 2px;\n}\n\n.aeModalCloseBtn {\n  border: none;\n  background: #f1f5f9;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #475569;\n}\n\n.aeModalCloseBtn:hover {\n  background: #e2e8f0;\n}\n\n.aeModalBody {\n  padding: 16px 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.aeModalTableWrap {\n  overflow-x: auto;\n  border-radius: 12px;\n  border: 1px solid #eef1f6;\n}\n\n.aeModal .tablePagination {\n  padding: 12px 20px 16px;\n  margin-top: 0;\n}\n\n.statBadgeStack {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n}\n\n.statBadgeStack .statBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.statBadgeStack .statBadge i {\n  font-size: 11px;\n}\n\n/* ===== Responsive : panneau statistiques annonces (filtres) ===== */\n@media (max-width: 768px) {\n  .adminDashboardStatsPanel .panelHeader {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .statsControls {\n    width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  /* Groupes de champs (mois/année, du/au) en grille 2 colonnes plutôt qu'empilés un par un */\n  .statsSelectGroup,\n  .statsDateRange {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n    width: 100%;\n  }\n\n  .statsDateField {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 4px;\n    min-width: 0;\n  }\n\n  .statsDateField span {\n    font-size: 11px;\n    font-weight: 700;\n    color: #94a3b8;\n    text-transform: uppercase;\n    letter-spacing: 0.02em;\n  }\n\n  .statsDateField input[type=\"date\"] {\n    width: 100%;\n    min-height: 40px;\n    padding: 8px 10px;\n  }\n\n  /* Le bouton reset ne casse plus la grille du/au quand il est inline dans statsDateRange */\n  .statsDateRange .statsResetBtn {\n    grid-column: 1 / -1;\n    justify-content: center;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    height: 36px;\n  }\n\n  .statsSelect {\n    width: 100%;\n    min-height: 40px;\n    text-align: center;\n    justify-content: center;\n  }\n\n  .statsControls > .adminDashboardBtnPrimary,\n  .statsActionsRow {\n    width: 100%;\n  }\n\n  .statsAnnoncesTable {\n    min-width: 760px;\n    font-size: 12px;\n  }\n\n  .statsAnnoncesTable thead th,\n  .statsAnnoncesTable tbody td {\n    padding: 8px 10px;\n  }\n\n  .panelStrong {\n    max-width: 160px;\n  }\n\n  .cellTruncate {\n    max-width: 110px;\n  }\n}\n\n/* Très petits écrans : une seule colonne pour éviter des dates trop compressées */\n@media (max-width: 420px) {\n  .statsSelectGroup,\n  .statsDateRange {\n    grid-template-columns: 1fr;\n  }\n\n  .statsDateRange .statsResetBtn {\n    grid-column: auto;\n  }\n}\n\n/* ===== Responsive : tableau statistiques annonces — cartes en scroll horizontal ===== */\n@media (max-width: 640px) {\n  .statsAnnoncesTableWrap {\n    border: none;\n    min-height: 0;\n    overflow: visible;\n  }\n\n  .statsAnnoncesTable,\n  .statsAnnoncesTable thead,\n  .statsAnnoncesTable tr,\n  .statsAnnoncesTable td {\n    display: block;\n    min-width: 0;\n  }\n\n  .statsAnnoncesTable thead {\n    position: absolute;\n    left: -9999px; /* masqué visuellement, gardé pour l'accessibilité */\n  }\n\n  /* Les cartes défilent horizontalement avec effet de snap */\n  .statsAnnoncesTable tbody {\n    display: flex;\n    flex-direction: row;\n    overflow-x: auto;\n    gap: 12px;\n    padding: 4px 4px 14px;\n    scroll-snap-type: x proximity;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .statsAnnoncesTable tbody::-webkit-scrollbar {\n    height: 6px;\n  }\n  .statsAnnoncesTable tbody::-webkit-scrollbar-thumb {\n    background: #e2e8f0;\n    border-radius: 999px;\n  }\n\n  .statsAnnoncesTable tbody tr {\n    display: block;\n    flex: 0 0 auto;\n    width: 78vw;\n    max-width: 280px;\n    scroll-snap-align: start;\n    height: auto;\n    background: #fff;\n    border: 1px solid #eef1f6;\n    border-radius: 14px;\n    padding: 12px 14px;\n    box-shadow: 0 1px 8px rgba(15, 23, 42, 0.04);\n  }\n\n  .statsAnnoncesTable tbody tr:hover {\n    background: #fff;\n  }\n\n  .statsAnnoncesTable tbody td {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    width: 100%;\n    padding: 8px 0;\n    border-bottom: 1px solid #f1f5f9;\n    text-align: right;\n    position: static;\n    box-shadow: none;\n    max-width: none;\n  }\n\n  .statsAnnoncesTable tbody td:last-child {\n    border-bottom: none;\n  }\n\n  .statsAnnoncesTable tbody td::before {\n    content: attr(data-label);\n    font-size: 11px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    color: #94a3b8;\n    text-align: left;\n    flex-shrink: 0;\n  }\n\n  /* Le titre de l'article devient l'en-tête visuel de la carte */\n  .statsAnnoncesTable tbody td.panelStrong.colSticky {\n    display: block;\n    text-align: left;\n    font-size: 14px;\n    padding: 0 0 10px;\n    border-bottom: 1px solid #f1f5f9;\n    margin-bottom: 6px;\n    white-space: normal;\n    max-width: none;\n    position: static;\n    box-shadow: none;\n  }\n  .statsAnnoncesTable tbody td.panelStrong.colSticky::before {\n    content: none;\n  }\n\n  .statsAnnoncesTable tbody td.colNum {\n    justify-content: center;\n  }\n  .statsAnnoncesTable tbody td.colNum::before {\n    content: none;\n  }\n  .statsAnnoncesTable tbody td.colNum .tableActionBtn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .cellTruncate {\n    max-width: 60%;\n    text-align: right;\n  }\n\n  .statBadgeStack {\n    align-items: flex-end;\n  }\n\n  .tablePagination {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .tablePaginationBtns {\n    justify-content: center;\n  }\n}\n\n/* ===== Modal détails événements — plein écran mobile ===== */\n@media (max-width: 640px) {\n  .aeModalOverlay {\n    padding: 0;\n    align-items: flex-end;\n  }\n\n  .aeModal {\n    max-width: 100%;\n    width: 100%;\n    max-height: 92vh;\n    border-radius: 20px 20px 0 0;\n    animation: aeModalSlideUp 0.22s ease-out;\n  }\n\n  .aeModalHeader {\n    padding: 18px 16px 14px;\n    position: sticky;\n    top: 0;\n    background: #fff;\n    z-index: 2;\n  }\n  .aeModalHeader::before {\n    content: \"\";\n    position: absolute;\n    top: 6px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 36px;\n    height: 4px;\n    border-radius: 999px;\n    background: #e2e8f0;\n  }\n\n  .aeModalTitle {\n    font-size: 14px;\n  }\n\n  .aeModalBody {\n    padding: 12px 0 16px 16px;\n  }\n\n  /* La table de la modal passe aussi en cartes défilables horizontalement */\n  .aeModal .statsAnnoncesTable,\n  .aeModal .statsAnnoncesTable thead,\n  .aeModal .statsAnnoncesTable tr,\n  .aeModal .statsAnnoncesTable td {\n    display: block;\n  }\n  .aeModal .statsAnnoncesTable thead {\n    position: absolute;\n    left: -9999px;\n  }\n  .aeModal .statsAnnoncesTable tbody {\n    display: flex;\n    overflow-x: auto;\n    gap: 10px;\n    padding: 2px 16px 10px 0;\n    scroll-snap-type: x proximity;\n    -webkit-overflow-scrolling: touch;\n  }\n  .aeModal .statsAnnoncesTable tbody::-webkit-scrollbar {\n    height: 6px;\n  }\n  .aeModal .statsAnnoncesTable tbody::-webkit-scrollbar-thumb {\n    background: #e2e8f0;\n    border-radius: 999px;\n  }\n  .aeModal .statsAnnoncesTable tbody tr {\n    flex: 0 0 auto;\n    width: 72vw;\n    max-width: 260px;\n    scroll-snap-align: start;\n    border: 1px solid #eef1f6;\n    border-radius: 12px;\n    padding: 10px 12px;\n  }\n  .aeModal .statsAnnoncesTable tbody td {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 6px 0;\n    border-bottom: 1px solid #f8fafc;\n    text-align: right;\n  }\n  .aeModal .statsAnnoncesTable tbody td::before {\n    content: attr(data-label);\n    font-size: 11px;\n    font-weight: 800;\n    color: #94a3b8;\n    text-transform: uppercase;\n  }\n\n  .aeModal .tablePagination {\n    padding: 10px 16px 14px;\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n\n@keyframes aeModalSlideUp {\n  from {\n    transform: translateY(24px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
